<svelte:options
	customElement={{
		tag: "svelte-quiz",
		shadow: "none",
	}}
/>

<script>
	let {
		quotes = JSON.stringify([
			{
				question:
					"Wann hat eine Theoretikerin gesagt, dass „es so etwas gibt wie ein Recht, Rechte zu haben [...], wissen wir erst, seitdem Millionen von Menschen auftauchten, die solche Rechte verloren hatten […]“?",
				data: "test-data",
				answers: ["1949", "1818"],
				correct_answer: "1949",
				answered: false,
				correct: false,
				answered_text:
					"Hannah Arendt (1906-1975) war eine jüdische deutsch-US-amerikanische Theoretikerin und Journalistin. Arendt verweist darauf, dass die Menschenrechte gerade die Entrechteten, also diejenigen, die den Schutz der Menschenrechte am dringlichsten bräuchten, nicht schützen können. Daher müssten sie, ausgehend von den Entrechteten, neu gedacht werden.",
			},
			{
				question:
					"Wann sagte ein Philosoph, dass „die Menschheit […] in ihrer größten Vollkommenheit in der Race der Weißen [ist]. […] Die N* sind weit tiefer, und am tiefsten steht ein Teil der amerikanischen Völkerschaften“?",
				data: "test-data",
				answers: ["1802", "1665"],
				correct_answer: "1802",
				answered: false,
				correct: false,
				answered_text:
					"Immanuel Kant (1724-1804) war einer der bekanntesten Philosophen der europäischen Aufklärung. Das Zitat stammt aus einer Vorlesung über „Physischen Geographie“, die Kant von 1755 bis zum Ende seiner Lehrtätigkeit 1796 regelmäßig hält. Das Zitat steht in einem Widerspruch zu Kants Ethik und Moralphilosophie, die die Gleichheit aller Menschen voraussetzt und auch für die Erklärung der Menschenrechte als grundlegend gilt.",
			},
		]),
	} = $props();
	let quotes_object = $state(JSON.parse(quotes));
	console.log(quotes_object);
	let current_quote_id = $state(0);
	let current_quote = $derived(quotes_object[current_quote_id]);

	const check_answer = (answer) => () => {
		const quote = quotes_object[current_quote_id];

		if (!quote.answered) {
			quote.answered = answer;
			if (quote.correct_answer == answer) quote.correct = true;
		}
	};

	const get_answer_class = (answer) => {
		const selected =
			current_quote.answered == answer ? "selected" : "not-selected";

		if (current_quote.answered && answer == current_quote.correct_answer)
			return selected + " correct";

		if (current_quote.answered && answer != current_quote.correct_answer)
			return selected + " wrong";

		return "";
	};

	const next_question = () => {
		current_quote_id += 1;
	};

	const previous_question = () => {
		current_quote_id -= 1;
	};
</script>

<main>
	<div class="quiz-container">
		<div class="quiz-question">
			{current_quote.question}
		</div>
		<div class="quiz-answers">
			{#each current_quote.answers as answer}
				<div class="quiz-answer">
					<button
						class={get_answer_class(answer)}
						disabled={current_quote.answered}
						onclick={check_answer(answer)}>{answer}</button
					>
				</div>
			{/each}
		</div>
	</div>

	{#if current_quote.answered}
		<div class="explain-answer">
			{#if current_quote.correct}
				<div class="correct-text">Richtig!</div>
			{:else}
				<div class="wrong-text">Leider falsch!</div>
			{/if}

			{current_quote.picture}
			{current_quote.answered_text}
		</div>

		<div class="nav-buttons">
			<button onclick={previous_question}>Previous quote</button>
			<button onclick={next_question}>Next quote</button>
		</div>
	{/if}
</main>

<style>
	main {
		max-width: 1280px;
		margin: 0 auto;
	}

	.quiz-question {
		border: 1px solid #e1e1e1;
		background-color: #3cc;
		color: #fff;
		padding: 2em;
		text-align: center;
		border-radius: 5px;
	}

	.quiz-answers {
		margin-top: 1em;
		display: flex;
		gap: 1em;
		justify-content: center;
	}

	.quiz-answer {
		width: 50%;
		transition: all 200ms;
	}

	.quiz-answer button,
	.nav-buttons button {
		background: #e1e1e1;
		border-radius: 5px;
		display: block;
		padding: 1em;
		width: 100%;
		font-size: 1em;
	}

	.quiz-answer .correct {
		background: #4caf50;
		color: white;
	}

	.quiz-answer .wrong {
		background: #f44336;
		color: white;
	}

	.quiz-answer .not-selected {
		opacity: 0.5;
	}

	.correct-text {
		color: #4caf50;
	}

	.wrong-text {
		color: #f44336;
	}

	.explain-answer {
		border: 1px solid #e1e1e1;
		padding: 2em;
		margin-top: 1em;
		border-radius: 5px;
		display: flex;
		flex-direction: column;
		gap: 0.5em;
	}

	.nav-buttons {
		display: flex;
		gap: 1em;
		margin-top: 1em;
	}
</style>
